import React, { useState, useEffect } from "react";
import { useNavigate, useParams } from "react-router-dom";
import PatientInformation from "./work-order/patient-information"
import FacilityInformation from "./work-order/facility-information"
import ClientInformation from "./work-order/client-information"
import CaseInformation from "./work-order/case-information"
import Notes from "./work-order/notes";
import CreateWorkOrder from "./work-order/create-work-order";

import axios from "axios";
import Swal from 'sweetalert2';
import { catchError } from '../helpers/catch-error-client'



const WorkOrderAdd = () => {
    const navigate = useNavigate();
    const params = useParams()

    const [workOrderData, setWorkOrderData] = useState(null);
    const [workOrderChanges, setWorkOrderChanges] = useState(null);
    const [patientLoader, setPatientLoader] = useState(true);
    const [facilityLoader, setFacilityLoader] = useState(true);
    const [clientLoader, setClientLoader] = useState(true);
    const [caseLoader, setCaseLoader] = useState(true);
    const [isBtn, setIsBtn] = useState(false);


    useEffect(() => {

        setWorkOrder();

    }, []);

    useEffect(() => {

        let new_obj = { ...workOrderData }
        if (workOrderChanges) {
            Object.keys(workOrderChanges).forEach(function (key) {

                new_obj[key] = workOrderChanges[key];

            });
            setWorkOrderData(new_obj)
        }

    }, [workOrderChanges]);

    const saveWorkOrder = async (e) => {

      

        if (!workOrderData?.patient_id || !workOrderData?.facility_id || !workOrderData?.client_id) {

      
            Swal.fire({ icon: "error", title: "Work Order Info", text: "Please enter patient, facility and client information.." });

        } else {

            setIsBtn(true);
            axios.post(process.env.REACT_APP_WEB_SERVICES_URL + "/client/create-work-order", { work_order_id: workOrderData?.work_order_id }, {
                headers: {
                    'Content-Type': 'application/json'
                },
                withCredentials: true
            }).then(async function (response) {

                if (response?.data?.status) {

                    navigate("/client/home")


                } else {

                    Swal.fire({ icon: "error", title: "Note Info", text: response?.data?.message });

                }
                setIsBtn(false)

            }).catch(function (error) {

                catchError(error, navigate)
                setIsBtn(false);

            });

        }


    }

    const setWorkOrder = async () => {


        if (params.work_order_id && params.work_order_id > 0) {
            await axios.get(process.env.REACT_APP_WEB_SERVICES_URL + "/client/get-work-order/" + params.work_order_id, {
                withCredentials: true
            })
                .then(function (response) {

                    if (response?.data?.status) {

                        setWorkOrderData(response?.data?.work_order);
                        setPatientLoader(false);
                        setFacilityLoader(false);
                        setClientLoader(false);
                        setCaseLoader(false);

                    } else {

                        Swal.fire({ icon: "error", title: "Pending client Action Work Order Failed to Load", text: response?.data?.message });

                    }

                })
                .catch(function (error) {

                    catchError(error, navigate)

                });
        }
        else {
            setPatientLoader(false);
            setFacilityLoader(false);
            setClientLoader(false);
            setCaseLoader(false);


        }
    }





    return (
        <div className="container-fluid  ">

            <div className="row px-2 py-4">
                <div className="col ">
                    <h5 className="text-dark fw-bold m-0 p-0">CREATE WORK ORDER REQUEST </h5>
                </div>


                <div className="col text-end">
                    {workOrderData?.status > 0 ?
                        <>
                            {(workOrderData && workOrderData?.follow_up_date && workOrderData?.follow_up_date !== "none") &&
                                <span className="patient-order"><label className="fw-bold fs-5" >FOLLOW-UP DATE: <span className="text-danger">{workOrderData.follow_up_date_f}</span> | </label> </span>
                            }
                            <span className="patient-order"><label className="fw-bold fs-5" >Work Order #: <span className="text-danger">{workOrderData.work_order_no}</span></label> </span>
                        </>
                        :
                        <button disabled={isBtn} onClick={() => { saveWorkOrder(); }} className="btn btn-primary " type="button"> {isBtn ? <><div className="spinner-border spinner-border-sm me-1" role="status"></div><span className="sr-only">Loading...</span></> : 'Save Work Order'}</button>
                    }

                </div>

            </div>





            {/* BEGIN OPEN WORK ORDERS - PATIENT INFORMATION    */}

            <div className="row mb-b" >

                <div className="col-md-6 mb-3" >
                    <PatientInformation
                        work_order={workOrderData}
                        is_loading={patientLoader}
                        onWorkOrderChange={(e) => {

                            setWorkOrderChanges(e);
                        }
                        }

                    />
                </div>
                <div className="col-md-6 mb-3" >
                    <FacilityInformation
                        work_order={workOrderData}
                        is_loading={facilityLoader}
                        onWorkOrderChange={(e) => {
                            setWorkOrderChanges(e);
                        }
                        }




                    />
                </div>


            </div>

            {/* END OPEN WORK ORDERS - PATIENT INFORMATION */}


            {(workOrderData?.work_order_id > 0) &&
                <>
                    {/* BEGIN OPEN WORK ORDERS - FACILITY INFORMATION    */}

                    <div className="row  " >


                    </div>
                    <div className="row " >

                        <div className="col-md-12 my-3 " >
                            <ClientInformation
                                work_order={workOrderData}
                                is_loading={clientLoader}
                                onWorkOrderChange={(e) => {
                                    setWorkOrderChanges(e);
                                }
                                }




                            />
                        </div>

                    </div>
                    {/* END OPEN WORK ORDERS - CASE INFORMATION */}




                    <div className="row " >

                        <div className="col-md-12 my-3 " >
                            <CaseInformation
                                work_order={workOrderData}
                                is_loading={caseLoader}
                                onWorkOrderChange={(e) => {
                                    setWorkOrderChanges(e);
                                }
                                }




                            />
                        </div>

                    </div>


                    {(workOrderData?.status > 0) ?
                        <div className="row " >

                            <div className="col-md-12 my-3 " >
                                <Notes work_order={workOrderData}
                                    is_loading={clientLoader}
                                    onWorkOrderChange={(e) => {
                                        setWorkOrderChanges(e);
                                    }
                                    } />

                            </div>

                        </div>
                        :
                        <div className="row ">

                            <div className="col-md-12 my-3 " >

                                <CreateWorkOrder work_order={workOrderData}
                                    is_loading={clientLoader}
                                    onWorkOrderChange={(e) => {
                                        setWorkOrderChanges(e);
                                    }
                                    } />

                            </div>

                        </div>
                    }






                </>
            }
        </div>


    )
};

export default WorkOrderAdd;